import React from "react";
import about from '../../images/about.jpg'

function About() {
  return (
    <div className="container my-5">
      <div className="d-block d-lg-flex">
        <div className="pe-0 pe-lg-3">
          <p className="h1 text-dark text-nowrap">GANJ MESOPOTAMIA
</p>
          <p className="h1 text-dark text-nowrap"> GENERAL TRADING LTD. </p>
          <div className="w-10 text-center pt-4">
          <img className="w-100 object-fit-cover"
height={250}       width={200}     src={about}
            alt="generalTwo"
            loading="lazy" />
          </div>
        </div>

        <div className="vl"></div>

        <div className="px-lg-5 w-100">
          <p className=" lh-lg fs-5 fw-light"><h5>Welcome to Ganj Mesopotamia</h5></p>
          <p className=" lh-lg fs-5 fw-light">
           
            
            At Ganj Mesopotamia, we bridge global markets by delivering high-quality products across diverse industries. As a trusted trading company based in the heart of Duhok, Iraq, we specialize in the import and export of <strong>food and beverages, detergents and disinfectants and cosmetic products.</strong>

          </p>
          <p className="text-justify lh-lg fs-5 fw-light">
          With a commitment to quality and innovation, we aim to support businesses and communities with reliable products that enhance everyday life and promote sustainable growth.
          </p>
          <p className=" lh-lg fs-5 fw-light"><h5>Explore our solutions and grow with us!</h5></p>

          {/* <Link
            to="/aboutus"
            className="btn btn-warning rounded-1 fs-5 fw-bold py-2"
          >
            About Us
          </Link> */}
        </div>
      </div>
    </div>
  );
}

export default About;
